import { ActivityContentProvider } from './providers/activities.provider';
import { BirthdayContentProvider } from './providers/birthdays.provider';
import { DiningContentProvider } from './providers/dining.provider';
import { MailContentProvider } from './providers/mail.provider';
import { NewsContentProvider } from './providers/news.provider';
import { PriorityNewsContentProvider } from './providers/priority-news.provider';
import { ScheduledVideoContentProvider } from './providers/scheduled-video.provider';
import { WeatherContentProvider } from './providers/weather.provider';
import { YouTubeLiveContentProvider } from './providers/youtube.provider';

// A provider owns its own enablement, tier and slot, so listing it here is the whole registration.
export const DEFAULT_CONTENT_PROVIDERS = [
  NewsContentProvider, DiningContentProvider, ActivityContentProvider, BirthdayContentProvider,
  PriorityNewsContentProvider, YouTubeLiveContentProvider, ScheduledVideoContentProvider, WeatherContentProvider, MailContentProvider
];
